import * as swcHelpers from '@swc/helpers';
import { takeLatest, put } from 'redux-saga/effects';
import { DataLayer } from '@grandvisionhq/analytics';
import { Actions } from '@grandvisionhq/auth';
import { clearEvents } from '../utils.js';

function* onPasswordChangeSuccess() {
    const data = makePasswordChange('success');
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(data));
}
function* onPasswordChangeError(action) {
    const { error  } = action;
    const data = makePasswordChange('error', makeDescriptiveErrorMessage(error));
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(data));
}
function makeDescriptiveErrorMessage(error) {
    if (typeof error === 'string') {
        return error;
    }
    return `${error ? error.statusCode : ''}`;
}
function makePasswordChange(status, errorCode) {
    return {
        event: 'myAccount',
        events: {
            category: 'my profile',
            action: swcHelpers.objectSpread({
                block: 'password change',
                interaction: 'edit',
                status
            }, errorCode && {
                errorCode
            })
        }
    };
}
/**
 * Main export
 */ var PasswordChangeSagas = [
    takeLatest(Actions.ResetPasswordActions.CHANGE_PASSWORD_SUCCESS, onPasswordChangeSuccess),
    takeLatest(Actions.ResetPasswordActions.CHANGE_PASSWORD_FAILED, onPasswordChangeError), 
];

export { PasswordChangeSagas as default, onPasswordChangeError, onPasswordChangeSuccess };
//# sourceMappingURL=passwordChange.js.map
